import { Outlet, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { planAllows } from "@/lib/plan";
import { Button } from "@/components/ui/button";
import { LockKey, CrownSimple } from "@phosphor-icons/react";

const COPY = {
  tactical_board: { it: "Lavagna Tattica", en: "Tactical Board" },
  medical: { it: "Area Medica", en: "Medical Health" },
  director: { it: "Direttore Sportivo", en: "Sport Director" },
  director_budget: { it: "Budget Direttore Sportivo", en: "Sport Director Budget" },
  players_to_sign: { it: "Da ingaggiare", en: "Players to sign" },
  squad: { it: "Rosa", en: "Squad" },
};

const CLUB_ONLY = new Set(["medical", "director_budget"]);

export default function PlanGate({ feature }) {
  const { user } = useAuth();
  const { tr } = useLang();
  if (planAllows(user, feature)) return <Outlet />;
  const name = COPY[feature] || { it: "Questa funzione", en: "This feature" };
  const plan = CLUB_ONLY.has(feature) ? "Club" : "Pro";
  return (
    <div className="max-w-xl mx-auto mt-16 text-center px-6" data-testid={`plan-gate-${feature}`}>
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 text-primary mb-5">
        <LockKey size={30} weight="fill" />
      </div>
      <h1 className="font-display font-black uppercase tracking-tight text-2xl">{tr(name.it, name.en)}</h1>
      <p className="text-muted-foreground mt-3">
        {tr(`${name.it} è disponibile dal piano ${plan}. Aggiorna il tuo abbonamento per sbloccarla.`,
            `${name.en} is available from the ${plan} plan. Upgrade your subscription to unlock it.`)}
      </p>
      <div className="flex items-center justify-center gap-3 mt-6">
        <Link to="/impostazioni"><Button variant="secondary" data-testid="plan-gate-settings" className="font-display uppercase tracking-wide">{tr("Gestisci piano", "Manage plan")}</Button></Link>
        <Link to="/pricing"><Button data-testid="plan-gate-upgrade" className="gap-2 font-display uppercase tracking-wide"><CrownSimple size={16} weight="fill" /> {tr("Vedi i piani", "See plans")}</Button></Link>
      </div>
    </div>
  );
}
